import clsx from 'clsx';

import type { ViewItem } from './CalendarItem.js';
import {
  calendarIndicatorBackgroundCSS,
  calendarIndicatorCSS,
  calendarOutlineCSS,
  calendarRangeCornersCSS,
  calendarRangeCornorVisibleCSS,
} from './CalendarOutlineIcon.sty.js';

type CalendarOutlineIconProps = {
  isCurrent: boolean;
  variant?: 'absolute' | 'relative' | 'absolute-relative' | 'relative-absolute';
} & Pick<ViewItem, 'highlightType'>;

/** @internal */
export const CalendarOutlineIcon =
  /* @__PURE__ */
  ({ isCurrent, highlightType, variant }: CalendarOutlineIconProps) => {
    return (
      <svg
        focusable="false"
        role="img"
        aria-hidden="true"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        id="calendar-outlines"
        x="0px"
        y="0px"
        viewBox="0 0 32 32"
        className={calendarOutlineCSS}
      >
        {variant === 'relative' && (
          <g>
            <path d="M12,1c0,0.6-0.4,1-1,1H7.6c-0.6,0-1-0.4-1-1s0.4-1,1-1H11C11.6,0,12,0.4,12,1z" />
            <path d="M18.7,1c0,0.6-0.4,1-1,1h-3.4c-0.6,0-1-0.4-1-1s0.4-1,1-1h3.4C18.3,0,18.7,0.4,18.7,1z" />
            <path d="M25.4,1c0,0.6-0.4,1-1,1H21c-0.6,0-1-0.4-1-1s0.4-1,1-1h3.4C25,0,25.4,0.4,25.4,1z" />
            <path
              d="M30.9,3.9c-0.6-1-1.8-2.2-2.8-2.8C27.6,0.8,27,1,26.7,1.5s-0.1,1.1,0.4,1.4l0,0c0.7,0.4,1.6,1.3,2,2
		C29.8,6,31.5,5,30.9,3.9"
            />
            <path d="M31,6.6c0.6,0,1,0.4,1,1V11c0,0.6-0.4,1-1,1s-1-0.4-1-1V7.6C30,7,30.4,6.6,31,6.6z" />
            <path d="M31,13.3c0.6,0,1,0.4,1,1v3.4c0,0.6-0.4,1-1,1s-1-0.4-1-1v-3.4C30,13.7,30.4,13.3,31,13.3z" />
            <path d="M31,25.4c-0.6,0-1-0.4-1-1V21c0-0.6,0.4-1,1-1s1,0.4,1,1v3.4C32,24.9,31.6,25.4,31,25.4z" />
            <path d="M30.9,28.1c-0.6,1-1.8,2.2-2.8,2.8" />
            <path d="M28.1,30.9c-1.1,0.7-2.1-1.1-1-1.7c0.7-0.4,1.6-1.3,2-2l0,0c0.3-0.5,0.9-0.7,1.4-0.4c0.5,0.3,0.7,0.9,0.4,1.4" />
            <path d="M20,31c0-0.6,0.4-1,1-1h3.4c0.6,0,1,0.4,1,1s-0.4,1-1,1H21C20.4,32,20,31.6,20,31z" />
            <path d="M13.3,31c0-0.6,0.4-1,1-1h3.4c0.6,0,1,0.4,1,1s-0.4,1-1,1h-3.4C13.7,32,13.3,31.6,13.3,31z" />
            <path d="M6.6,31c0-0.6,0.4-1,1-1H11c0.6,0,1,0.4,1,1s-0.4,1-1,1H7.6C7,32,6.6,31.6,6.6,31z" />
            <path d="M3.9,30.9c-1-0.6-2.2-1.8-2.8-2.8" />
            <path d="M1.1,28.1c-0.7-1.1,1.1-2.1,1.7-1c0.4,0.7,1.3,1.6,2,2l0,0c0.5,0.3,0.7,0.9,0.4,1.4C5,31,4.4,31.1,3.9,30.9" />
            <path d="M1,25.4c-0.6,0-1-0.4-1-1V21c0-0.6,0.4-1,1-1s1,0.4,1,1v3.4C2,24.9,1.6,25.4,1,25.4z" />
            <path d="M1,18.7c-0.6,0-1-0.4-1-1v-3.4c0-0.6,0.4-1,1-1s1,0.4,1,1v3.4C2,18.2,1.6,18.7,1,18.7z" />
            <path d="M1,6.6c0.6,0,1,0.4,1,1V11c0,0.6-0.4,1-1,1s-1-0.4-1-1V7.6C0,7,0.4,6.6,1,6.6z" />
            <path
              d="M3.9,1.1c1.1-0.6,2.1,1,1,1.7c-0.7,0.4-1.6,1.3-2,2l0,0C2.6,5.4,2,5.5,1.5,5.3C1,5,0.8,4.4,1.1,3.9
		C1.7,2.9,2.9,1.7,3.9,1.1"
            />
          </g>
        )}
        {variant === 'absolute-relative' && (
          <g>
            <path d="M25.4,1c0,0.6-0.4,1-1,1H21c-0.6,0-1-0.4-1-1s0.4-1,1-1h3.4C25,0,25.4,0.4,25.4,1z" />
            <path
              d="M30.9,3.9L30.9,3.9L30.9,3.9c-0.6-1-1.8-2.2-2.8-2.8C27.6,0.8,27,1,26.7,1.5s-0.1,1.1,0.4,1.4l0,0c0.7,0.4,1.6,1.3,2,2
		C29.8,6,31.5,5,30.9,3.9z"
            />
            <path d="M31,6.6c0.6,0,1,0.4,1,1V11c0,0.6-0.4,1-1,1s-1-0.4-1-1V7.6C30,7,30.4,6.6,31,6.6z" />
            <path d="M31,13.3c0.6,0,1,0.4,1,1v3.4c0,0.6-0.4,1-1,1s-1-0.4-1-1v-3.4C30,13.7,30.4,13.3,31,13.3z" />
            <path d="M31,25.4c-0.6,0-1-0.4-1-1V21c0-0.6,0.4-1,1-1s1,0.4,1,1v3.4C32,24.9,31.5,25.4,31,25.4z" />
            <path
              d="M28.1,30.9L28.1,30.9c1-0.6,2.2-1.8,2.8-2.8c0.3-0.5,0.1-1.1-0.4-1.4s-1.1-0.1-1.4,0.4l0,0c-0.4,0.7-1.3,1.6-2,2
		C26,29.8,27,31.5,28.1,30.9z"
            />
            <path d="M20,31c0-0.6,0.4-1,1-1h3.4c0.6,0,1,0.4,1,1s-0.4,1-1,1H21C20.4,32,20,31.6,20,31z" />
            <path
              d="M8,0C3.6,0,0,3.6,0,8v16c0,4.4,3.6,8,8,8c0,0,9.2,0,9.7,0s1-0.4,1-1s-0.5-1-1-1S8,30,8,30c-3.3,0-6-2.7-6-6V8
		c0-3.3,2.7-6,6-6c0,0,9.5,0,9.8,0s0.9-0.3,0.9-1s-0.6-1-1-1C17.4,0,8,0,8,0z"
            />
          </g>
        )}
        {variant === 'relative-absolute' && (
          <g>
            <path d="M6.6,31c0-0.6,0.4-1,1-1H11c0.6,0,1,0.4,1,1s-0.4,1-1,1H7.6C7,32,6.6,31.5,6.6,31z" />
            <path
              d="M1.1,28.1c-0.7-1.1,1.1-2.1,1.7-1c0.4,0.7,1.3,1.6,2,2l0,0c0.5,0.3,0.7,0.9,0.4,1.4C5,31,4.4,31.2,3.9,30.9
		C2.9,30.3,1.7,29.1,1.1,28.1"
            />
            <path d="M1,25.4c-0.6,0-1-0.4-1-1V21c0-0.6,0.4-1,1-1s1,0.4,1,1v3.4C2,25,1.6,25.4,1,25.4z" />
            <path d="M1,18.7c-0.6,0-1-0.4-1-1v-3.4c0-0.6,0.4-1,1-1s1,0.4,1,1v3.4C2,18.3,1.6,18.7,1,18.7z" />
            <path d="M1,6.6c0.6,0,1,0.4,1,1V11c0,0.6-0.4,1-1,1s-1-0.4-1-1V7.6C0,7.1,0.5,6.6,1,6.6z" />
            <path
              d="M3.9,1.1C5,0.5,6,2.2,4.9,2.9c-0.7,0.4-1.6,1.3-2,2l0,0C2.6,5.4,2,5.5,1.5,5.3C1,5,0.8,4.4,1.1,3.9
		C1.7,2.9,2.9,1.7,3.9,1.1"
            />
            <path d="M12,1c0,0.6-0.4,1-1,1H7.6c-0.6,0-1-0.4-1-1s0.4-1,1-1H11C11.6,0,12,0.4,12,1z" />
            <path
              d="M24,32c4.4,0,8-3.6,8-8V8c0-4.4-3.6-8-8-8c0,0-9.2,0-9.7,0s-1,0.4-1,1s0.5,1,1,1S24,2,24,2c3.3,0,6,2.7,6,6v16
		c0,3.3-2.7,6-6,6c0,0-9.5,0-9.8,0s-0.9,0.3-0.9,1s0.6,1,1,1C14.6,32,24,32,24,32z"
            />
          </g>
        )}
        {variant === 'absolute' && (
          <g>
            <path
              d="M32,24c0,4.4-3.6,8-8,8H8c-4.4,0-8-3.6-8-8V8c0-4.4,3.6-8,8-8h16c4.4,0,8,3.6,8,8V24z M24,30c3.3,0,6-2.7,6-6
		V8c0-3.3-2.7-6-6-6H8C4.7,2,2,4.7,2,8v16c0,3.3,2.7,6,6,6H24z"
            />
          </g>
        )}
        {isCurrent && (
          <g>
            <path
              className={calendarIndicatorBackgroundCSS}
              d="M20,31.1c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S20,28.9,20,31.1z"
            />
            <path
              className={calendarIndicatorCSS}
              d="M18,31.1c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-1.1,0.9-2,2-2S18,30,18,31.1z"
            />
          </g>
        )}
        {(highlightType === 'first' || highlightType === 'last') && (
          <g>
            <g
              className={clsx([
                calendarRangeCornersCSS,
                highlightType === 'first' ? calendarRangeCornorVisibleCSS : '',
              ])}
            >
              <path d="M32 24C32 28.4183 28.4183 32 24 32H32V24Z" />
              <path d="M24 0C28.4183 0 32 3.58172 32 8V0H24Z" />
            </g>
            <g
              className={clsx([
                calendarRangeCornersCSS,
                highlightType === 'last' ? calendarRangeCornorVisibleCSS : '',
              ])}
            >
              <path d="M0 24C0 28.4183 3.58172 32 8 32H0V24Z" />
              <path d="M8 0C3.58172 0 0 3.58172 0 8V0H8Z" />
            </g>
          </g>
        )}
      </svg>
    );
  };
